import { IoMdClose } from 'react-icons/io';
import React from 'react';
import styled from 'styled-components';
import { HorizontalDiv, InputDate } from '../Common';
import colors from './../../res/styles/Colors';
import dimension from './../../res/styles/Responsive';
import { getDateOrEmpty } from './../../utils/DateFormatter';
import LinePoint from './LinePoint';

export default function Date({
    className,
    date,
    content,
    hasLine = true,
    color = 'black',
    isEditable = false,
    id,
    onChange,
    onDelete
}) {
    const formattedDate = getDateOrEmpty(date, 'DD/MMM/YYYY');

    return (
        <StyledHorizontalDiv className={className}>
            {isEditable ? (
                <DateColumn>
                    <StyledInputDate
                        id={id}
                        color={color}
                        dateAsLong={date}
                        onChange={(event) => {
                            onChange && onChange(id, event.target.value);
                        }}
                    />
                    {date != null && (
                        <DeleteButton onClick={() => onDelete && onDelete(id)} title='Remove date'>
                            <IoMdClose />
                        </DeleteButton>
                    )}
                </DateColumn>
            ) : (
                <StyledDate>{formattedDate}</StyledDate>
            )}
            <StyledLinePoint color={color} hasLine={hasLine} circlePosition='top' />
            <ContentText>{content}</ContentText>
        </StyledHorizontalDiv>
    );
}

const StyledHorizontalDiv = styled(HorizontalDiv)`
    p {
        font-size: 13px;
        margin-bottom: 1rem;
    }
`;

const DateColumn = styled.div`
    flex-basis: 80px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const DeleteButton = styled.button`
    background-color: ${colors.red};
    color: white;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    max-width: 28px;
    max-height: 28px;
    cursor: pointer;
    padding: 0;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    svg {
        width: 20px;
        height: 20px;
    }

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    }

    &:active {
        transform: scale(0.95);
    }
`;

const StyledDate = styled.p`
    flex-basis: 80px;
    flex-shrink: 0;
    color: ${colors.darker_gray};
`;

const ContentText = styled.p`
    font-weight: bold;
`;

const StyledLinePoint = styled(LinePoint)`
    flex-shrink: 0;
    width: 30px;
    height: ${({ hasLine }) => (hasLine ? 'auto' : 'fit-content')};
`;

const StyledInputDate = styled(InputDate)`
    && {
        font-size: 12px;
        margin-bottom: 4px;
        @media ${dimension.md} {
            width: 150px;
            height: 30px;
        }

        :focus {
            box-shadow: none;
            border-color: ${({ color }) => color};
        }
    }
`;
